import axios from 'axios';

export default axios.create({
  baseURL: `${process.env.REACT_APP_EVO_CLIENT_API_BASE_URL}/api/`
});